const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 219px)',
  },

  tableHead: {
    position: 'relative',
  },

  logoColumn: {
    width: 45,
    flex: 'none',
    padding: '4px',
    display: 'flex',
    justifyContent: 'flex-end',
  },

  logoWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  logo: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    overflow: 'hidden',
  },

  logoImg: {
    width: 24,
    display: 'block',
  },

  company: {
    display: 'flex',
    alignItems: 'center',
  },

  companyName: {
    marginLeft: 15,
  },

  cellLink: {
    color: '#5786D7',
    fontWeight: 500,
  },

  searchAndSettings: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 30,
    marginLeft: 20,
  },
});

export default styles;
